// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__av_q6","actionsCol":"EnrolledClinics_actionsCol__3Vqxf"};